import * as React from "react";
import styled from "styled-components";
import Text, { TextProps } from "../Text";
import { select } from "@hubper/theme";

// @ts-ignore
// tslint:disable-next-line:no-empty
function nope() {}

type Props = {
  style?: React.CSSProperties;
  className?: string;
  onClick?: () => void;
  href?: string;
  disabled?: boolean;
} & TextProps;

const CustomText = styled(Text)<Props>`
  transition: 0.2s;
  color: ${p =>
    p.disabled ? select.color(["grey", 5], p) : select.findColor(p)};
  cursor: ${p => (p.disabled ? "not-allowed" : "pointer")};
  text-decoration: underline;
  padding: 0 2px;

  &:hover {
    color: ${p =>
      p.disabled
        ? select.color(["grey", 5], p)
        : select.color(["primary", 5], p)};
  }
`;

function Link(
  { style, className, onClick, href, disabled, children, ...rest }: Props,
  ref: any
) {
  let anchorProps = {};
  if (href) {
    anchorProps = {
      href,
      as: "a",
      target: "_blank"
    };
  }

  return (
    <CustomText
      {...anchorProps}
      style={style}
      className={className}
      ref={ref}
      data-testid="link"
      onClick={(!disabled && onClick) || nope}
      disabled={disabled}
      {...rest}
    >
      {children}
    </CustomText>
  );
}

export default React.forwardRef(Link);
